import { createSelector } from '@reduxjs/toolkit';

import configSelector from './config';

const mapsPlacemarkSelector = createSelector(
  configSelector,
  config => config.maps.placemark,
);

export default mapsPlacemarkSelector;
